import { memo } from 'react';

import TraceIconSpinner from '@/components/ui/traceIconSpinner';

import { GroupCard } from './groupCard/groupCard';

import { WorkflowGroupsQueryQuery } from '@/apollo/graphql';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';

type Props = {
  isLoading: boolean;
  workflow: WorkflowGroupsQueryQuery['workflowByRowId'];
  fetchMoreGroups: () => void;
  hasFilters: boolean;
};

export const GroupsList = memo(
  ({ isLoading, workflow, fetchMoreGroups, hasFilters }: Props) => {
    if (isLoading) return <TraceIconSpinner />;
    if (!workflow) return null;

    const groups = workflow.groups.nodes;
    const nbGroups = workflow.groups.totalCount;
    const pageInfo = workflow.groups.pageInfo;

    return (
      <div className="flex flex-col gap-2 px-5 py-4">
        {!nbGroups ? (
          <div className="text-muted-foreground py-1.5 text-sm">
            {`No groups to display here${
              hasFilters ? ' (a filter is being applied)' : ''
            }`}
          </div>
        ) : (
          groups
            .filter(g => !!g)
            .map(group => <GroupCard key={group.rowId} group={group} />)
        )}
        {isLoading ? (
          <TraceIconSpinner className="mt-4 size-[34px]" />
        ) : (
          pageInfo?.hasNextPage && (
            <Button
              className="mt-3 h-12 w-full"
              variant="outline"
              onClick={fetchMoreGroups}
              data-testid={TestId.WorkflowGroups.GroupsList.LoadMoreButton}
            >
              Show more groups
            </Button>
          )
        )}
      </div>
    );
  }
);
